import { CreditCardType } from '@constants/cards'
import useSWR from 'swr'

export const METHOD_TYPE_CREDIT_CARD = 'creditCard'
export const METHOD_TYPE_PAYPAL = 'payPalAccount'

export type PaymentMethodType =
  | typeof METHOD_TYPE_CREDIT_CARD
  | typeof METHOD_TYPE_PAYPAL

export interface GetPaymentMethodResponse {
  card_info: {
    provider: CreditCardType
    last_two_digits: string
    expiration_date: string
  }
  payment_error: {
    message: string
  }
  type: PaymentMethodType
  payer_email: string
}

export const useGetPaymentMethod = () =>
  useSWR<GetPaymentMethodResponse>('payments/payment-methods')
